import { faImage, faMinusSquare, faPlusSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { formatDate } from '../../utils/dateHelper/dateHelper';
import './Photo.scss';
import Modal from '../Modal/Modal';
import PropTypes from 'prop-types';
import DeletePhoto from '../DeletePhoto/DeletePhoto';
import AddPhoto from '../AddPhoto/AddPhoto';
import Attachment from '../../api/controllers/Attachment/Attachment';

// Common Photo Component
const Photo = ({ photo, number, refetchPhotos, setError, completed }) => {
  const [photoOpen, setPhotoOpen] = useState();
  const [modalOpen, setModalOpen] = useState();
  const [image, setImage] = useState();

  const getModalContent = () => {
    switch (modalOpen) {
      case 'destroy':
        return (
          <DeletePhoto
            photoId={photo.id}
            refetchPhotos={refetchPhotos}
            setModalOpen={setModalOpen}
          />
        );
      case 'edit':
        return (
          <AddPhoto edit photo={photo} refetchPhotos={refetchPhotos} setModalOpen={setModalOpen} />
        );
    }
  };

  const handleDownload = () => {
    const converter = new FileReader();
    converter.readAsDataURL(image);

    converter.onloadend = event => {
      const a = document.createElement('a');
      a.download = photo.attachmentFileName;
      a.href = event.target.result;
      a.click();
    };
  };

  const getImage = () => {
    Attachment.download(photo.id)
      .then(blob => {
        setImage(blob);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getImage();
  }, []);

  return (
    <>
      <div className="photo_container">
        <div className="photo_header" onClick={() => setPhotoOpen(!photoOpen)}>
          <FontAwesomeIcon icon={faImage} className={'photo_icon'} />
          <div className="photo_type_number">
            Photo #{number} :{' '}
            {photo.classification.charAt(0).toUpperCase() +
              photo.classification.replaceAll('_', ' ').substring(1).toLowerCase()}
          </div>
          <FontAwesomeIcon
            icon={photoOpen ? faMinusSquare : faPlusSquare}
            className={photoOpen ? 'minus_icon' : 'plus_icon'}
            data-testid={photoOpen ? 'minus_icon' : 'plus_icon'}
          />
        </div>
        {photoOpen && (
          <div className="photo_body">
            {image && (
              <div className="image_display">
                <img
                  className="image"
                  src={URL.createObjectURL(image)}
                  data-testid="image_display"
                  onClick={() => handleDownload()}
                />
              </div>
            )}
            <div className="photo_description">{photo.description}</div>
            {!completed && (
              <div className="photo_buttons">
                <button className="edit_button" onClick={() => setModalOpen('edit')}>
                  Edit
                </button>
                <button className="destroy_button" onClick={() => setModalOpen('destroy')}>
                  Destroy
                </button>
              </div>
            )}
            <div className="photo_info">
              <div className="created_info">Created at {formatDate(photo.createdAt)}</div>
              <div className="updated_info">Last updated at {formatDate(photo.updatedAt)}</div>
            </div>
          </div>
        )}
      </div>
      {modalOpen && (
        <Modal
          title={modalOpen == 'edit' ? 'Edit Photo' : ''}
          content={getModalContent()}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
};

Photo.propTypes = {
  photo: PropTypes.object,
  number: PropTypes.number,
  refetchPhotos: PropTypes.func,
  setError: PropTypes.func,
  completed: PropTypes.bool,
};

export default Photo;
